import { motion } from "framer-motion";

export default function Hero() {
  return (
    <section style={{ textAlign: "center", paddingTop: "180px" }}>
      <motion.h1
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        style={{
          fontSize: "64px",
          fontWeight: "700",
          background: "linear-gradient(90deg, #60a5fa, #a78bfa, #34d399)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        Building Modern Web Apps
      </motion.h1>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
        style={{ fontSize: "20px", color: "#94a3b8", marginTop: 20 }}
      >
        Full Stack Developer • Python • React • Cloud Engineering
      </motion.p>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
        style={{ marginTop: 30 }}
      >
        <button
          style={{
            padding: "14px 28px",
            borderRadius: "12px",
            border: "none",
            background: "linear-gradient(90deg, #3b82f6, #8b5cf6)",
            color: "white",
            fontWeight: "600",
            cursor: "pointer",
          }}
        >
          View Projects
        </button>
      </motion.div>
    </section>
  );
}